import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor() {}

  /**
   * dateをstringにformatする
   * @param target input date
   */
  toStringDate(target: Date): string {
    return moment(target).format('YYYYMMDDHHmmss');
  }

  /**
   * csvファイルの末尾につける日付のフォーマット
   */
  getCsvDate(): string {
    return moment().format('YYYYMMDD_HHmmss');
  }

  /**
   * 加算、もしくは減算した日付を返す
   * @param days 計算日付
   */
  getAddedDateTrancated(days: number): Date {
    return moment().startOf('day').add(days, 'days').toDate();
  }

  /**
   * 日付を指定されたフォーマットで文字列に変換する
   * @param date 対象の日付
   * @param format フォーマット文字列
   */
  formatDate(date: Date, format: string): string {
    return moment(date).format(format);
  }
}
